import React from "react";

const AttendanceList = ({ attendanceRecords }) => {
  return (
    <div className="glass-card rounded-2xl border-slate-800/80 shadow-2xl overflow-hidden animate-fade-in-up">
      <div className="px-6 py-5 border-b border-slate-900/60 flex items-center justify-between bg-slate-900/20">
        <h2 className="text-lg font-bold text-slate-100 flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Historial de Asistencias
        </h2>
        <span className="text-xs font-semibold px-2.5 py-1 bg-slate-950 border border-slate-850 rounded-lg text-slate-400">
          {attendanceRecords.length} registros
        </span>
      </div>

      <div className="overflow-x-auto">
        {attendanceRecords.length === 0 ? (
          <div className="p-12 text-center text-slate-500">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-slate-700 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2" />
            </svg>
            <p className="text-sm">No se encontraron registros de asistencia para esta consulta.</p>
          </div>
        ) : (
          <table className="min-w-full divide-y divide-slate-900">
            <thead className="bg-slate-950/60">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  Empleado
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  DNI
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  Fecha
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  Hora
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  Tipo
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-slate-400 uppercase tracking-wider">
                  GPS
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-900 bg-transparent">
              {attendanceRecords.map((record, index) => (
                <tr
                  key={
                    record.id ??
                    `${record.dni}-${record.date}-${record.time}-${index}`
                  }
                  className="hover:bg-slate-900/35 transition-colors duration-150"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-200">
                    {record.employeeName}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-400 font-mono">
                    {record.dni}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-400 font-mono">
                    {record.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-400 font-mono">
                    {record.time}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-3 py-1 inline-flex text-xs leading-5 font-bold rounded-full uppercase tracking-wide border ${
                        record.type === "entrada"
                          ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/25"
                          : "bg-indigo-500/10 text-indigo-400 border-indigo-500/25"
                      }`}
                    >
                      {record.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    {record.latitude && record.longitude ? (
                      <a 
                        href={`https://maps.google.com/?q=${record.latitude},${record.longitude}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg text-cyan-400 transition-colors tooltip"
                        title="Ver ubicación GPS"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </a>
                    ) : (
                      <span className="text-slate-600">-</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AttendanceList;
